export function operacaoRecebimentoInRequest(params = {}) {
  return {
    type: '@operacaorecebimento/RECEBIMENTO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRecebimento(desc_codigo) {
  return {
    type: '@operacaorecebimento/FIND_RECEBIMENTO',
    payload: { desc_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaorecebimento/FAILED_REQUEST',
  };
}

export function deleteOperacaoRecebimento(desc_codigo, params) {
  return {
    type: '@operacaorecebimento/DELETE_RECEBIMENTO',
    payload: { desc_codigo, params },
  };
}

export function updateOperacaoRecebimento(operacaorecebimento, params) {
  return {
    type: '@operacaorecebimento/UPDATE_RECEBIMENTO',
    payload: { operacaorecebimento, params },
  };
}

export function storeOperacaoRecebimento(operacaorecebimento, params) {
  return {
    type: '@operacaorecebimento/STORE_RECEBIMENTO',
    payload: { operacaorecebimento, params },
  };
}

export function successInRequest(
  operacaorecebimento,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaorecebimento/SUCCESS_IN_REQUEST',
    payload: { operacaorecebimento, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaorecebimento) {
  return {
    type: '@operacaorecebimento/SUCCESS_REQUEST',
    payload: { operacaorecebimento },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaorecebimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaorecebimento/RECORD_FILTERING',
    payload: { params },
  };
}
